import React from "react"
import strings from "../../localization/strings"
import { ELoggedInUserType, IDate, IObjectTimecardDocument, IPayrollPayGroupData, IPayrollStatusDocument, ITimecard, ITimecardDates, IUserDocument } from "../../models"
import { FlatButton, FontIcon, Chip } from "material-ui"
import AppStateStore from "../../stores/AppStateStore"
import TimecardDateRange from "./TimecardDateRange"
import * as timecardHelper from "../../helpers/timecardHelper"
import moment from "moment"
import EmployeeTimecardReport from "./timecard_report/EmployeeTimecardReport"
import * as userHelper from "../../helpers/userHelper"
import * as payrollStatusHelper from "../../helpers/payrollStatusHelper"
import {readValidationMessage} from "../../api"

interface IProps {
    user: IUserDocument
    readonly: boolean
    refenenceDate: IDate
    loggedInUserType: ELoggedInUserType
    lockData: IPayrollStatusDocument[]
    payrollPayGroupData: IPayrollPayGroupData
    employeeName: string
    timecardId: string
    timecard: IObjectTimecardDocument
    showNoteIcon: boolean
    byPopup: boolean
    handleChangeReferenceDate(date: IDate, timecardDates: ITimecardDates): void
    handleRecalculate(): void
    handleOpenPunchDrawer(): void
    priorPeriodAdjustmentsMode: boolean
    reloadTimecard : () => void
}

const EmployeeTimecardActionBar: React.SFC<IProps> = (props: IProps) => {
    const timecardHasValidationMessages = props.timecard && props.timecard.ApprovalValidationList && props.timecard.ApprovalValidationList.length > 0;

    return (
        <div style={{ paddingLeft: 20, paddingRight: 20, paddingBottom: 20 }}>
            <div className="pageHeading" style={{ marginBottom: 3 }}>
                {strings.Timecard}
            </div>
            <div style={{ marginLeft: -15, display: "flex", justifyContent: "space-between" }}>
                <TimecardDateRange
                    referenceDate={props.refenenceDate}
                    payrollPayGroupData={props.payrollPayGroupData}
                    handleChangeReferenceDate={props.handleChangeReferenceDate}
                />
                <div style={{ display: "flex", alignItems: "center" }}>
                    {props.loggedInUserType !== ELoggedInUserType.Employee && !props.readonly &&
                        !payrollStatusHelper.isLocked(props.lockData, props.user.Id, ELoggedInUserType.AccountUser) &&
                        <FlatButton
                            data-intercom-target={"menu-Employees-Timecards-Btn-Recalculate"}
                            label={strings.Recalculate}
                            backgroundColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor}
                            hoverColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor}
                            labelStyle={{ color: "white" }}
                            onClick={() => userHelper.checkLoggedInUserPermission(props.user) &&
                                AppStateStore.setConfirmDialogContent({
                                    content: strings.Are_you_sure_you_want_to_recalculate_this_employee_timecard,
                                    confirm: props.handleRecalculate
                                })
                            }
                        />
                    }
                    {!props.byPopup && props.loggedInUserType !== ELoggedInUserType.Employee && !props.readonly && !props.priorPeriodAdjustmentsMode &&
                        <FlatButton
                            data-intercom-target={"menu-Employees-Timecards-Btn-AddOrEditPunches"}
                            label={strings.Add_Edit_Punches}
                            backgroundColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor}
                            hoverColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor}
                            style={{ marginLeft: 10 }}
                            labelStyle={{ color: "white" }}
                            onClick={() => userHelper.checkLoggedInUserPermission(props.user) && props.handleOpenPunchDrawer()}
                        />
                    }
                    {props.loggedInUserType !== ELoggedInUserType.Employee &&
                        <EmployeeTimecardReport
                            user={props.user}
                            payrollPayGroupData={props.payrollPayGroupData}
                            referenceDate={props.refenenceDate}
                        />
                    }
                    {props.loggedInUserType !== ELoggedInUserType.Employee &&
                        <div style={{ marginLeft: 5, marginTop: 3 }}>
                            {timecardHasValidationMessages &&
                                <Chip
                                    style={{ marginRight: 10, backgroundColor: "#f44336", cursor: "pointer"}}
                                    onTouchTap={() => userHelper.checkLoggedInUserPermission(props.user) &&
                                        AppStateStore.setNoteDrawerContent({
                                            drawerTitle: `${props.employeeName} - ${strings.Timecard} ${strings.Notes}`,
                                            objectData: {
                                                ObjectId: props.timecardId,
                                                TimecardRef: {
                                                    UserId: props.user.Id,
                                                    StartDate: moment(timecardHelper.getTimecardDateByPayrollPayGroupData(props.refenenceDate, props.payrollPayGroupData).StartDate).utc(true).format(),
                                                    Timecard: props.timecard
                                                }
                                            },
                                            objectName: props.employeeName,
                                            dataType: "timecard",
                                            validationMessages: props.timecard ? props.timecard.ApprovalValidationList : null,
                                            readValidationMessage: async (msgeId) =>{
                                                const res = await readValidationMessage(props.user.Id, msgeId, props.timecard.StartDate as unknown as Date)
                                                props.reloadTimecard()
                                                return res.data
                                                
                                            },
                                            
                                    })}                                
                                >
                                    <span style={{color: "#ffffff"}}>
                                        <i className="fa-solid fa-circle-exclamation" style={{marginRight: 5}}/>
                                        {props.timecard.ApprovalValidationList.length} Validation Msg(s)
                                    </span>
                                </Chip>
                            }
                            
                            {!timecardHasValidationMessages && 
                            <FontIcon
                                data-intercom-target={"menu-Employees-Timecards-Btn-OpenNotes"}
                                className="fa fa-info-circle"
                                style={{ fontSize: 20, color: "#777777", cursor: "pointer" }}
                                onTouchTap={() => userHelper.checkLoggedInUserPermission(props.user) &&
                                    AppStateStore.setNoteDrawerContent({
                                        drawerTitle: `${props.employeeName} - ${strings.Timecard} ${strings.Notes}`,
                                        objectData: {
                                            ObjectId: props.timecardId,
                                            TimecardRef: {
                                                UserId: props.user.Id,
                                                StartDate: moment(timecardHelper.getTimecardDateByPayrollPayGroupData(props.refenenceDate, props.payrollPayGroupData).StartDate).utc(true).format(),
                                                Timecard: props.timecard
                                            }
                                        },
                                        objectName: props.employeeName,
                                        dataType: "timecard",
                                    })}
                            />
                                }
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default EmployeeTimecardActionBar
